// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-fa520dd0","container":"container-f35c033e","title":"title-d3e5ba41","message":"message-c2340467","children":"children-db126e17"};